import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FileUploader } from 'ng2-file-upload';
import { environment } from '../../environments/environment';

@Component({
  selector: 'upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss'],
  inputs: ['height', 'number']
})

export class UploadComponent implements OnInit {
    private uploader: FileUploader;
    private uploading: boolean = false;
    private image: string = 'http://rileybook.com/wp-content/uploads/2016/07/placeholder.png';
    private height: number;
    private number: number;

    public constructor(private route: ActivatedRoute) {}

    public ngOnInit() {
        let image = new Image();
        image.onload = (() => { this.image = environment.endpoint + '/images/' + this.route.snapshot.params['id'] + '/' + this.number + '.jpg'; });
        image.onerror = (() => { this.image = 'http://rileybook.com/wp-content/uploads/2016/07/placeholder.png'; });
        image.src = environment.endpoint + '/images/' + this.route.snapshot.params['id'] + '/' + this.number + '.jpg';

        let token = localStorage.getItem('amt_flyer_token');
        this.uploader = new FileUploader({ url: environment.endpoint + '/images/upload/' + this.route.snapshot.params['id'] + '/' + this.number, autoUpload: true, authToken: token });
        this.uploader.onBeforeUploadItem = (item: any) => {
            this.uploading = true;
        };
        this.uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
            let res = JSON.parse(response);
            console.log(res, response);
            this.uploading = false;
            if(status === 200 && res.status === 'OK') {
                this.image = environment.endpoint + '/' + res.results;
            } else {
                alert(res.results);
            }
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/upload/upload.component.ts